var _title, _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "edit")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "path-1",
    points: "0 0.115340536 22.2773197 0.115340536 22.2773197 20.1008403 0 20.1008403"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-3",
    points: "0 0.115340536 22.2773197 0.115340536 22.2773197 20.1008403 0 20.1008403"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "materials-icon",
    transform: "translate(6.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(12.303645, 10.714230) scale(-1, 1) translate(-12.303645, -10.714230) translate(0.803645, 0.214230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0525322953,0.504471269 C-0.100609189,0.304659344 0.110556132,0.0127185674 0.308044406,0.151270788 C7.55439273,5.23522797 18.3183326,12.894366 16.2636671,15.6060651 C14.2155292,18.3090299 5.38367955,7.4633104 0.0525322953,0.504471269",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9418213,16.5568707 C15.8263953,16.6037727 15.7624654,16.7442393 15.8002845,16.8787235 C16.0742399,17.8540928 16.3853928,19.8242145 18.5052315,20.069014 C20.3945291,20.2871321 21.7964264,19.3499304 22.250981,18.3435722 C22.3507613,18.1227023 22.1489212,17.8969268 21.9509149,17.9957559 C19.6556577,19.1419824 20.5593789,14.1670244 17.3120127,14.8370524 C17.2057048,14.858948 17.1135919,14.9283437 17.095045,15.0512221 C17.0391971,15.4221305 16.8179812,16.201397 15.9418213,16.5568707",
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.d2aebc26.svg";
export { ForwardRef as ReactComponent };